import api from './api';

export const workflowConfigService = {
  // Get all workflow configurations (admin only)
  getWorkflows: async () => {
    const response = await api.get('/workflow-config/workflows');
    return response.data;
  },

  // Add or update workflow configuration (admin only)
  addWorkflowConfig: async (updateType, name, configData) => {
    const response = await api.post(`/workflow-config/add/${updateType}/${name}`, configData);
    return response.data;
  },

  // Get workflow configuration by name (admin only)
  getWorkflowByName: async (name) => {
    const response = await api.get(`/workflow-config/${name}`);
    return response.data;
  },

  // Get workflow steps (admin only)
  getWorkflowSteps: async (name) => {
    const response = await api.get(`/workflow-config/${name}/steps`);
    return response.data;
  },

  // Get workflow step details (admin only)
  getWorkflowStep: async (name, stepId) => {
    const response = await api.get(`/workflow-config/${name}/step/${stepId}`);
    return response.data;
  },

  // Get workflow step actions (admin only)
  getWorkflowStepActions: async (name, stepId) => {
    const response = await api.get(`/workflow-config/${name}/step/${stepId}/actions`);
    return response.data;
  },
};
